import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Modal, Row } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment";
import { Spin } from "antd";
import {
  POST_GetBillingCustomerDetails,
  POST_GetCompanyLUTDocumentInvoiceDateCheckExpiredOrNot,
  POST_GetCustomerContactPersonDDLByCustomerProject,
  POST_GetCustomerDDLListAJAX,
  POST_GetCustomerProjectAddressDDLList,
  POST_GetCustomerProjectList,
  POST_GetExpenseListByCompanyID,
  POST_GetPerformaInvoiceDetailByID,
  POST_GetPerformaInvoiceInwardNoListByCustomerID,
  POST_GetPerformaInvoiceTCNoListByInwardIDs,
  POST_GetPerformaInvoiceTestAndMachiningListByInwardMaterialID,
  POST_GetVoucherSeriesDDLList,
  POST_PerformaInvoiceInsert,
  POST_PerformaInvoiceUpdate,
  POST_ValidateCustomerCredit,
} from "../../../helpers/url_helper";
import { post } from "../../../helpers/api_helper";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import CustomMultiSelect from "../../../CustomControls/CustomMultiSelect";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CommonMaterialInformation from "./CommonMaterialInformation";
import {
  customConfirmDialog,
  errorMessage,
  successMessage,
} from "../CommonFunctions";

const AddPerformaInvoice = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [performaInvoiceNoOptions, setPerformaInvoiceNoOptions] = useState([]);
  const [inwardNoOptions, setInwardNoOptions] = useState([]);
  const [tCNoOptions, setTCNoOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [projectAddressOptions, setProjectAddressOptions] = useState([]);
  const [contactPersonOptions, setContactPersonOptions] = useState([]);
  const [modeByOptions, setModeByOptions] = useState([]);

  const getModeByDDL = () => {
    setModeByOptions([
      {
        value: 1,
        label: "Email",
      },
      {
        value: 2,
        label: "Post",
      },
      {
        value: 3,
        label: "Hand to Hand",
      },
      {
        value: 4,
        label: "Courier",
      },
    ]);
  };

  const validationSchema = Yup.object().shape({
    VoucherSeriesIDEncrypted: Yup.string().required(
      "Proforma Invoice No is required field"
    ),
    PerformaInvoiceDate: Yup.string().required(
      "Proforma Invoice Date is required field"
    ),
    CustomerIDEncrypted: Yup.string().required("Customer is required field"),
    BillingCustomerIDEncrypted: Yup.string().required(
      "Billing Customer is required field"
    ),
    CustomerProjectIDEncrypted: Yup.string().required(
      "Project is required field"
    ),
    CustomerProjectAddressIDEncrypted: Yup.string().required(
      "Address is required field"
    ),
    CustomerProjectContactPersonIDEncrypted: Yup.string().required(
      "Contact Person is required field"
    ),
    ModeOfDispatch: Yup.string().required("Mode Of Dispatch is required field"),
    InwardIDs: Yup.array()
      .required("Inward No is required field")
      .min(1, "Inward No is required field")
      .nullable(),
    InwardMaterialIDs: Yup.array()
      .required("TC No is required field")
      .min(1, "TC No is required field")
      .nullable(),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      PerformaInvoiceIDEncrypted: PrimaryIdParam
        ? window.atob(PrimaryIdParam)
        : "",
      VoucherSeriesIDEncrypted: "",
      PerformaInvoiceNo: "",
      PerformaInvoiceDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
      BillingCustomerIDEncrypted: "",
      BillingCustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectAddressIDEncrypted: "",
      CustomerProjectContactPersonIDEncrypted: "",
      ModeOfDispatch: "",
      BillingRemarks: "",
      GSTNumber: "",
      Narration: "",
      BillingCustomerOutstandingAmount: "0",
      InwardIDs: [],
      InwardMaterialIDs: [],
      ListOfInwardMaterialsDetails: [],
      ListOfExpense: [],
      DiscountPercentageApplyToAll: "",
      unitOptions: [],
      ListOfGSTPlans: [],
      GSTType: 0,
      CalculateGST: true,
      CustomerInSEZ: false,
      GSTPercentage: "0.00",
      GrossAmount: "0.00", ///* Item wise Total Amount */
      ItemTotalDiscountAmount: "0.00", ///* Item wise Total Discount Amount */
      ItemNetAmount: "0.00", ///* Item wise Total Net Amount */
      AdditionalAmount: "0.00", ///* Expense Total Amount */
      ExpenseTotalDiscountAmount: "0.00", ///* Expense Total Discount Amount */
      ExpenseNetAmount: "0.00", ///* Expense Total NetAmount */
      TotalGrossAmount: "0.00", ///* ItemNetAmount + ExpenseNetAmount */
      DiscountAmount: "0.00", ///* ItemTotalDiscountAmount + ExpenseTotalDiscountAmount */
      GSTAmount: "0.00", ///* Total GST Tax Amount */
      RoundingOff: "0.00", ///* Rounding Amount */
      NetAmount: "0.00", ///* TotalGrossAmount + Total Tax Amount */
      InvoiceStatus: false,
      FormID: 51, ///* 51 = Proforma Invoice */
      calcGross: false,
      calcTaxAndNet: false,
      IsLUTCertificateExpired: false,
      GSTSEZType: 0,
      InvoiceType: 1,
      IsPrintLineItemRemarks: false,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      VoucherSeriesIDEncrypted,
      PerformaInvoiceDate,
      CustomerIDEncrypted,
      CustomerName,
      BillingCustomerIDEncrypted,
      BillingCustomerName,
      BillingCustomerOutstandingAmount,
      CustomerProjectIDEncrypted,
      InvoiceStatus,
      CalculateGST,
      CustomerInSEZ,
      IsLUTCertificateExpired,
      GSTSEZType,
      InvoiceType,
      IsPrintLineItemRemarks,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    if (InvoiceStatus == true) {
      return;
    }

    setIsLoading(true);

    let testList = [],
      machiningList = [],
      expenseList = [];

    Promise.all(
      values?.ListOfInwardMaterialsDetails?.map((item) => {
        item?.ListOfTests?.map((test) => {
          testList.push({
            ...test,
            DiscountPercentage: test?.DiscountPercentage
              ? test?.DiscountPercentage
              : "0.00",
            UnitID: test?.UnitID ? test?.UnitID : 0,
          });
        });
        item?.ListOfMachining?.map((machining) => {
          machiningList.push({
            ...machining,
            DiscountPercentage: machining?.DiscountPercentage
              ? machining?.DiscountPercentage
              : "0.00",
          });
        });
      })
    );

    Promise.all(
      values?.ListOfExpense?.filter((x) => x.IsSelected == true)?.map(
        (item) => {
          expenseList.push({
            ...item,
            DiscountPercentage: item?.DiscountPercentage
              ? item?.DiscountPercentage
              : "0.00",
          });
        }
      )
    );

    let payload = {
      ...values,
      PerformaInvoiceDate: values?.PerformaInvoiceDate
        ? moment(values?.PerformaInvoiceDate)
            .format("YYYY-MM-DD")
            .replace(/^\-/, "")
        : "",
      DiscountAmount: values?.DiscountAmount?.toString(),
      InwardList: values?.InwardMaterialIDs?.map((x) => ({
        InwardIDEncrypted: x?.InwardIDEncrypted,
        InwardMaterialIDEncrypted: x?.value,
      })),
      TestList: testList,
      MachiningList: machiningList,
      ExpenseList: expenseList,
      GSTDetail: values?.ListOfGSTPlans?.filter(
        (x) => parseFloat(x?.GSTAmount) > 0
      ),
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
      ModifiedByEncrypted: AuthUser?.ReferenceIDEncrypt,
    };

    delete payload["InwardIDs"];
    delete payload["InwardMaterialIDs"];
    delete payload["ListOfInwardMaterialsDetails"];
    delete payload["ListOfExpense"];
    delete payload["ListOfGSTPlans"];
    delete payload["unitOptions"];
    delete payload["InvoiceStatus"];
    delete payload["FormID"];
    // console.log(payload);

    post(
      PrimaryIdParam ? POST_PerformaInvoiceUpdate : POST_PerformaInvoiceInsert,
      payload
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate(-1);
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getModeByDDL();
    if (PrimaryIdParam) {
      getPerformaInvoiceDetails();
    } else {
      getExpenseList();
    }
  }, []);

  const getPerformaInvoiceDetails = async () => {
    setIsLoading(true);
    await post(POST_GetPerformaInvoiceDetailByID, {
      PerformaInvoiceIDEncrypted: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          let p = response?.PerformaInvoiceInfo;
          formik.setFieldValue(
            "VoucherSeriesIDEncrypted",
            p?.VoucherSeriesIDEncrypted
          );
          formik.setFieldValue("PerformaInvoiceNo", p?.PerformaInvoiceNo);
          formik.setFieldValue(
            "PerformaInvoiceDate",
            p?.PerformaInvoiceDate ? new Date(p?.PerformaInvoiceDate) : ""
          );
          formik.setFieldValue("CustomerIDEncrypted", p?.CustomerIDEncrypted);
          formik.setFieldValue("CustomerName", p?.CustomerName);
          formik.setFieldValue(
            "BillingCustomerIDEncrypted",
            p?.BillingCustomerIDEncrypted
          );
          formik.setFieldValue("BillingCustomerName", p?.BillingCustomerName);
          formik.setFieldValue(
            "CustomerProjectIDEncrypted",
            p?.CustomerProjectIDEncrypted
          );
          formik.setFieldValue(
            "CustomerProjectAddressIDEncrypted",
            p?.CustomerProjectAddressIDEncrypted
          );
          formik.setFieldValue(
            "CustomerProjectContactPersonIDEncrypted",
            p?.CustomerProjectContactPersonIDEncrypted
          );
          formik.setFieldValue("ModeOfDispatch", p?.ModeOfDispatch);
          formik.setFieldValue("BillingRemarks", p?.BillingRemarks);
          formik.setFieldValue("GSTNumber", p?.GSTNo);

          formik.setFieldValue("Narration", p?.Narration);
          formik.setFieldValue(
            "BillingCustomerOutstandingAmount",
            p?.BillingCustomerOutstandingAmount
          );
          formik.setFieldValue(
            "InwardIDs",
            response?.InwardNoSelectedList?.map((item) => ({
              label: item.InwardNo,
              value: item.InwardIDEncrypted,
              InwardIDEncrypted: item.InwardIDEncrypted,
            }))
          );
          formik.setFieldValue(
            "InwardMaterialIDs",
            response?.TCNoSelectedList?.map((item) => ({
              label: item.TCNo,
              value: item.InwardMaterialIDEncrypted,
              InwardIDEncrypted: item.InwardIDEncrypted,
            }))
          );
          formik.setFieldValue(
            "ListOfInwardMaterialsDetails",
            response?.ListOfInwardMaterialsDetails?.map((item) => ({
              ...item,
              IsSelected: true,
            }))
          );
          formik.setFieldValue("ListOfExpense", response?.ExpenseList);
          formik.setFieldValue("ListOfGSTPlans", response?.GSTList);
          formik.setFieldValue("GSTType", p?.GSTType);
          formik.setFieldValue("GSTPercentage", p?.GSTPercentage);
          formik.setFieldValue("GrossAmount", p?.GrossAmount);
          formik.setFieldValue("CustomerInSEZ", p?.CustomerInSEZ);
          formik.setFieldValue(
            "IsPrintLineItemRemarks",
            p?.IsPrintLineItemRemarks
          );
          let itemTotalDiscountAmount = 0,
            itemNetAmount = 0,
            expenseTotalDiscountAmount = 0,
            expenseNetAmount = 0,
            totalGrossAmount = 0;

          Promise.all(
            response?.ListOfInwardMaterialsDetails?.map((item) => {
              Promise.all(
                item?.ListOfTests?.map((test) => {
                  itemTotalDiscountAmount =
                    itemTotalDiscountAmount +
                    parseFloat(test?.DiscountAmount ? test?.DiscountAmount : 0);
                  itemNetAmount =
                    itemNetAmount +
                    parseFloat(test?.NetAmount ? test?.NetAmount : 0);
                })
              );
              Promise.all(
                item?.ListOfMachining?.map((m) => {
                  itemTotalDiscountAmount =
                    itemTotalDiscountAmount +
                    parseFloat(m?.DiscountAmount ? m?.DiscountAmount : 0);
                  itemNetAmount =
                    itemNetAmount + parseFloat(m?.NetAmount ? m?.NetAmount : 0);
                })
              );
            })
          );

          Promise.all(
            response?.ExpenseList?.filter((x) => x.IsSelected == true)?.map(
              (e) => {
                expenseTotalDiscountAmount =
                  expenseTotalDiscountAmount +
                  parseFloat(e?.DiscountAmount ? e?.DiscountAmount : 0);
                expenseNetAmount =
                  expenseNetAmount +
                  parseFloat(e?.NetAmount ? e?.NetAmount : 0);
              }
            )
          );

          totalGrossAmount =
            parseFloat(itemNetAmount) + parseFloat(expenseNetAmount);

          formik.setFieldValue(
            "ItemTotalDiscountAmount",
            itemTotalDiscountAmount.toFixed(2)
          );
          formik.setFieldValue("ItemNetAmount", itemNetAmount.toFixed(2));
          formik.setFieldValue("AdditionalAmount", p?.AdditionalAmount);
          formik.setFieldValue(
            "ExpenseTotalDiscountAmount",
            expenseTotalDiscountAmount.toFixed(2)
          );
          formik.setFieldValue("ExpenseNetAmount", expenseNetAmount.toFixed(2));
          formik.setFieldValue("TotalGrossAmount", totalGrossAmount.toFixed(2));
          formik.setFieldValue("DiscountAmount", p?.DiscountAmount);
          formik.setFieldValue("GSTAmount", p?.GSTAmount);
          formik.setFieldValue("RoundingOff", p?.RoundingOff);
          formik.setFieldValue("NetAmount", p?.NetAmount);
          formik.setFieldValue("InvoiceStatus", p?.InvoiceStatus);
          setInwardNoOptions(
            response?.InwardListDDL?.map((item) => ({
              label: item.InwardNo,
              value: item.InwardIDEncrypted,
              InwardIDEncrypted: item.InwardIDEncrypted,
            }))
          );
          setTCNoOptions(
            response?.TCNoListDDL?.map((item) => ({
              label: item.TCNo,
              value: item.InwardMaterialIDEncrypted,
              InwardIDEncrypted: item.InwardIDEncrypted,
            }))
          );
          getProjectDDL(p?.BillingCustomerIDEncrypted);
          getProjectAddressDDL(
            p?.BillingCustomerIDEncrypted,
            p?.CustomerProjectIDEncrypted
          );
          getContactPersonDDL(
            p?.BillingCustomerIDEncrypted,
            p?.CustomerProjectIDEncrypted
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTestAndMachiningListByInwardMaterialID = async (
    inwardMaterialIDs
  ) => {
    setIsLoading(true);
    await post(POST_GetPerformaInvoiceTestAndMachiningListByInwardMaterialID, {
      CustomerIDEncrypted: CustomerIDEncrypted,
      InwardMaterialIDsEncrypted: inwardMaterialIDs,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ListOfInwardMaterialsDetails",
            response?.ListOfInwardMaterialsDetails?.map((item) => ({
              ...item,
              IsSelected: true,
            }))
          );
          formik.setFieldValue("calcGross", true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getExpenseList = async () => {
    setIsLoading(true);
    await post(POST_GetExpenseListByCompanyID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ListOfExpense",
            response?.ExpenseList?.map((item) => ({
              ...item,
              IsSelected: false,
              Qty: 1,
              ExpenseRate: item.DefaultRate,
              GrossAmount: "0.00",
              DiscountPercentage: "",
              DiscountAmount: "0.00",
              NetAmount: "0.00",
              PerformaInvoiceExpenseIDEncrypted: "",
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!PerformaInvoiceDate) {
      formik.setFieldValue("PerformaInvoiceDate", "");
    }
    getPerformaInvoiceNoDDL();

    if (BillingCustomerIDEncrypted) {
      if (CustomerInSEZ) {
        GetCompanyLUTDocumentInvoiceDateCheckExpiredOrNot(PerformaInvoiceDate);
        getBillingCustomerDetails(BillingCustomerIDEncrypted);
      }
    }
  }, [PerformaInvoiceDate]);

  const getPerformaInvoiceNoDDL = async () => {
    setIsLoading(true);
    await post(POST_GetVoucherSeriesDDLList, {
      TranType: 15, // 15 = Proforma Invoice
      TranDate: PerformaInvoiceDate
        ? moment(PerformaInvoiceDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setPerformaInvoiceNoOptions(
            response?.VoucherSeriesList?.map((item) => ({
              label: item.VoucherSeries,
              value: item.VoucherSeriesIDEncrypt,
            }))
          );
          if (VoucherSeriesIDEncrypted) {
            if (
              response?.VoucherSeriesList?.filter(
                (x) => x.VoucherSeriesIDEncrypt == VoucherSeriesIDEncrypted
              )?.length == 0
            ) {
              formik.setFieldValue("VoucherSeriesIDEncrypted", "");
            }
          } else {
            /*select the value when there is only one option while insert only*/
            if (response?.VoucherSeriesList?.length == 1 && !PrimaryIdParam) {
              formik.setFieldValue(
                "VoucherSeriesIDEncrypted",
                response?.VoucherSeriesList[0].VoucherSeriesIDEncrypt
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const loadOptionsCutomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getCustomerDDL_AJAX = (inputValue) => {
    return post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const getBillingCustomerDetails = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetBillingCustomerDetails, {
      CustomerIDEncrypted: customerID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InvoiceDate: PerformaInvoiceDate,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue("GSTNumber", response?.GSTNo);
          formik.setFieldValue("GSTType", response?.GSTType);
          formik.setFieldValue("CalculateGST", response?.CalculateGST);
          formik.setFieldValue("CustomerInSEZ", response?.CustomerInSEZ);
          formik.setFieldValue("GSTSEZType", response?.GSTSEZType);

          formik.setFieldValue(
            "GSTPercentage",
            response?.GSTPercentage?.toString()
          );
          formik.setFieldValue(
            "BillingCustomerOutstandingAmount",
            response?.OutstandingAmount
          );
          formik.setFieldValue(
            "ListOfGSTPlans",
            response?.GSTPlanDetailList?.map((item) => ({
              ...item,
              GSTPercentage: item?.GSTPercentage?.toString(),
              GSTAmount: "0.00",
              TaxableAmount: "0.00",
              PerformaInvoiceGSTDetailIDEncrypted: "",
            }))
          );
          formik.setFieldValue("calcTaxAndNet", true);

          if (response?.CustomerInSEZ) {
            if (PerformaInvoiceDate) {
              GetCompanyLUTDocumentInvoiceDateCheckExpiredOrNot(
                PerformaInvoiceDate
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const GetCompanyLUTDocumentInvoiceDateCheckExpiredOrNot = async (InvDate) => {
    setIsLoading(true);
    await post(POST_GetCompanyLUTDocumentInvoiceDateCheckExpiredOrNot, {
      InvoiceDate: InvDate,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "IsLUTCertificateExpired",
            response?.IsLUTCertificateExpired
          );
          if (response?.IsLUTCertificateExpired) {
            customConfirmDialog(
              "The LUT certificate for the selected invoice date has expired.",
              "Do you want to create Proforma Invoices?",
              fnCallbackValidateCustomerCredit,
              false
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getProjectDDL = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerProjectList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypt: customerID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setProjectOptions(
            response?.CustomerProjectDDLList?.map((item) => ({
              label: item.ProjectName,
              value: item.CustomerProjectIDEncrypt,
            }))
          );
          if (
            response?.CustomerProjectDDLList?.length > 0 &&
            CustomerProjectIDEncrypted &&
            response?.CustomerProjectDDLList?.filter(
              (x) => x.CustomerProjectIDEncrypt == CustomerProjectIDEncrypted
            ).length == 0
          ) {
            formik.setFieldValue("CustomerProjectIDEncrypted", "");
            setProjectAddressOptions([]);
            formik.setFieldValue("CustomerProjectAddressIDEncrypted", "");
            setContactPersonOptions([]);
            formik.setFieldValue("CustomerProjectContactPersonIDEncrypted", "");
          } else {
            /*select the value when there is only one option while insert only*/
            if (
              response?.CustomerProjectDDLList?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                "CustomerProjectIDEncrypted",
                response?.CustomerProjectDDLList[0].CustomerProjectIDEncrypt
              );
              getProjectAddressDDL(
                customerID,
                response?.CustomerProjectDDLList[0].CustomerProjectIDEncrypt
              );
              getContactPersonDDL(
                customerID,
                response?.CustomerProjectDDLList[0].CustomerProjectIDEncrypt
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getInwardNoList = async (customerID) => {
    if (customerID) {
      setIsLoading(true);
      await post(POST_GetPerformaInvoiceInwardNoListByCustomerID, {
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
        CustomerIDEncrypted: customerID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            setInwardNoOptions(
              response?.InwardList?.map((item) => ({
                label: item.InwardNo,
                value: item.InwardIDEncrypted,
                InwardIDEncrypted: item.InwardIDEncrypted,
              }))
            );
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setInwardNoOptions([]);
      formik.setFieldValue("InwardIDs", []);
      setTCNoOptions([]);
      formik.setFieldValue("InwardMaterialIDs", []);
    }
  };

  const getTCNoList = async (inwardIDs) => {
    if (inwardIDs) {
      setIsLoading(true);
      await post(POST_GetPerformaInvoiceTCNoListByInwardIDs, {
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
        InwardIDsEncrypted: inwardIDs,
        PerformaInvoiceIDEncrypted: PrimaryIdParam
          ? window.atob(PrimaryIdParam)
          : "",
      })
        .then((response) => {
          if (response?.IsSuccess) {
            let tcList = response?.TCNoList?.map((item) => ({
              label: item.TCNo,
              value: item.InwardMaterialIDEncrypted,
              InwardIDEncrypted: item.InwardIDEncrypted,
            }));
            setTCNoOptions(tcList);
            formik.setFieldValue("InwardMaterialIDs", tcList);
            getTestAndMachiningListByInwardMaterialID(
              Array.from(tcList, (x) => x.value).join(",")
            );
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setTCNoOptions([]);
      formik.setFieldValue("InwardMaterialIDs", []);
      formik.setFieldValue("ListOfInwardMaterialsDetails", []);
      formik.setFieldValue("calcGross", true);
    }
  };

  const getProjectAddressDDL = async (customerID, projectID) => {
    if (customerID && projectID) {
      setIsLoading(true);
      await post(POST_GetCustomerProjectAddressDDLList, {
        CustomerIDEncrypted: customerID,
        CustomerProjectIDEncrypted: projectID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            setProjectAddressOptions(
              response?.ProjectAddressDDLList?.map((item) => ({
                label: item.Address,
                value: item.CustomerProjectAddressIDEncrypted,
              }))
            );
            /*select the value when there is only one option while insert only*/
            if (
              response?.ProjectAddressDDLList?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                "CustomerProjectAddressIDEncrypted",
                response?.ProjectAddressDDLList[0]
                  .CustomerProjectAddressIDEncrypted
              );
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setProjectAddressOptions([]);
      formik.setFieldValue("CustomerProjectAddressIDEncrypted", "");
    }
  };

  const getContactPersonDDL = async (customerID, projectID) => {
    if (customerID && projectID) {
      setIsLoading(true);
      await post(POST_GetCustomerContactPersonDDLByCustomerProject, {
        CustomerIDEncrypted: customerID,
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        CustomerProjectIDEncrypted: projectID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            //set only billing contact person
            setContactPersonOptions(
              response?.ListOfContactPersons?.filter(
                (x) => x?.IsBilling == true
              )?.map((item) => ({
                label: item?.ContactPerson,
                value: item?.CustomerProjectContactPersonIDEncrypted,
                IsBilling: item?.IsBilling,
                IsReporting: item?.IsReporting,
                IsDispatch: item?.IsDispatch,
                IsDispatchMaterial: item?.IsDispatchMaterial,
              }))
            );
            /*select the value when there is only one option while insert only*/
            if (
              response?.ListOfContactPersons?.filter(
                (x) => x?.IsBilling == true
              )?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                "CustomerProjectContactPersonIDEncrypted",
                response?.ListOfContactPersons?.filter(
                  (x) => x?.IsBilling == true
                )[0].CustomerProjectContactPersonIDEncrypted
              );
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setContactPersonOptions([]);
      formik.setFieldValue("CustomerProjectContactPersonIDEncrypted", "");
    }
  };

  const handleChangeCustomer = (e) => {
    formik.setFieldValue("CustomerIDEncrypted", e?.value ?? "");
    formik.setFieldValue("CustomerName", e?.label ?? "");
    if ((e?.value ?? "") !== CustomerIDEncrypted) {
      setInwardNoOptions([]);
      formik.setFieldValue("InwardIDs", []);
      setTCNoOptions([]);
      formik.setFieldValue("InwardMaterialIDs", []);
      getInwardNoList(e?.value ?? "");
      formik.setFieldValue("ListOfInwardMaterialsDetails", []);
      formik.setFieldValue("calcGross", true);
    }
    if (e) {
      formik.setFieldValue("BillingCustomerIDEncrypted", e?.value);
      formik.setFieldValue("BillingCustomerName", e?.label ?? "");
      getProjectDDL(e?.value);
      getBillingCustomerDetails(e?.value);
      ValidateCustomerCredit(e?.value);
    }
  };

  const handleChangeBillingCustomer = (e) => {
    formik.setFieldValue("BillingCustomerIDEncrypted", e?.value ?? "");
    formik.setFieldValue("BillingCustomerName", e?.label ?? "");
    if (e) {
      getProjectDDL(e?.value);
      getBillingCustomerDetails(e?.value);
      ValidateCustomerCredit(e?.value);
    } else {
      setProjectOptions([]);
      formik.setFieldValue("CustomerProjectIDEncrypted", "");
      setProjectAddressOptions([]);
      formik.setFieldValue("CustomerProjectAddressIDEncrypted", "");
      setContactPersonOptions([]);
      formik.setFieldValue("CustomerProjectContactPersonIDEncrypted", "");
      formik.setFieldValue("GSTNumber", "");
      formik.setFieldValue("GSTType", 0);
      formik.setFieldValue("GSTPercentage", "0.00");
      formik.setFieldValue("BillingCustomerOutstandingAmount", "0.00");
      formik.setFieldValue("ListOfGSTPlans", []);
      formik.setFieldValue("calcTaxAndNet", true);
    }
  };

  const handleChangeInwardNos = (e) => {
    formik.setFieldValue("InwardIDs", e ?? []);
    getTCNoList(Array.from(e ?? [], (x) => x.value).join(","));
    formik.setFieldValue("DiscountPercentageApplyToAll", "");
  };

  const handleChangeTCNos = (e) => {
    formik.setFieldValue("InwardMaterialIDs", e ?? []);
    getTestAndMachiningListByInwardMaterialID(
      Array.from(e ?? [], (x) => x.value).join(",")
    );
    formik.setFieldValue("DiscountPercentageApplyToAll", "");
  };

  const handleChangeProject = (e) => {
    formik.setFieldValue("CustomerProjectIDEncrypted", e?.value ?? "");
    formik.setFieldValue("CustomerProjectAddressIDEncrypted", "");
    getProjectAddressDDL(BillingCustomerIDEncrypted, e?.value ?? "");
    formik.setFieldValue("CustomerProjectContactPersonIDEncrypted", "");
    getContactPersonDDL(BillingCustomerIDEncrypted, e?.value ?? "");
  };

  const ValidateCustomerCredit = async (customerId) => {
    setIsLoading(true);
    await post(POST_ValidateCustomerCredit, {
      CustomerIDEncrypt: customerId,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess == false) {
          customConfirmDialog(
            response?.Message,
            "Do you want to create more Proforma Invoices?",
            fnCallbackValidateCustomerCredit,
            false
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallbackValidateCustomerCredit = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} Proforma Invoice
              </h4>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <div
                    className={`${InvoiceStatus == false ? "" : "disableDiv"}`}
                  >
                    <Row>
                      <Col lg={3}>
                        {!PrimaryIdParam ? (
                          <Field
                            label="Proforma Invoice Date"
                            name="PerformaInvoiceDate"
                            placeholder={"Select Proforma Invoice Date"}
                            component={CustomFlatpickr}
                            options={{
                              altInput: true,
                              altFormat: "j-M-Y",
                              dateFormat: "d-m-Y",
                              maxDate: new Date(),
                            }}
                            required
                          />
                        ) : (
                          <Field
                            label="PerformaInvoiceDate"
                            name="PerformaInvoiceDate"
                            component={CustomInput}
                            value={moment(PerformaInvoiceDate).format(
                              "DD-MMM-yyyy"
                            )}
                            required
                            disabled={true}
                          />
                        )}
                      </Col>
                      <Col lg={3}>
                        {!PrimaryIdParam ? (
                          <Field
                            label="Proforma Invoice No"
                            name="VoucherSeriesIDEncrypted"
                            placeholder={"Select Proforma Invoice No"}
                            options={performaInvoiceNoOptions}
                            component={CustomSelect}
                            required
                            autoFocus
                          />
                        ) : (
                          <Field
                            label="Proforma Invoice No"
                            name="PerformaInvoiceNo"
                            component={CustomInput}
                            required
                            disabled={true}
                          />
                        )}
                      </Col>
                      <Col lg={3}>
                        {!PrimaryIdParam ? (
                          <Field
                            label="Customer"
                            name="CustomerIDEncrypted"
                            placeholder={"Select Customer"}
                            loadOptionsFn={loadOptionsCutomer}
                            component={CustomSelectAsync}
                            title={CustomerName}
                            labelFieldName="CustomerName"
                            required
                            onChange={handleChangeCustomer}
                          />
                        ) : (
                          <Field
                            label="Customer"
                            name="CustomerName"
                            component={CustomInput}
                            required
                            disabled={true}
                          />
                        )}
                      </Col>
                      <Col lg={3}>
                        <span
                          className="me-2 mt-1 fs-12 text-primary"
                          style={{ float: "right" }}
                        >
                          Outstanding Amount :{" "}
                          {BillingCustomerOutstandingAmount}
                        </span>
                        <Field
                          label="Billing Customer"
                          name="BillingCustomerIDEncrypted"
                          placeholder={"Select Billing Customer"}
                          loadOptionsFn={loadOptionsCutomer}
                          component={CustomSelectAsync}
                          title={BillingCustomerName}
                          labelFieldName="BillingCustomerName"
                          required
                          onChange={handleChangeBillingCustomer}
                        />
                      </Col>
                      <Col lg={6}>
                        <Field
                          label="Inward No"
                          name="InwardIDs"
                          placeholder={"Select Inward No"}
                          options={inwardNoOptions}
                          component={CustomMultiSelect}
                          isMulti={true}
                          menuPosition="fixed"
                          required
                          onChange={handleChangeInwardNos}
                        />
                      </Col>
                      <Col lg={6}>
                        <Field
                          label="TC No"
                          name="InwardMaterialIDs"
                          placeholder={"Select TC No"}
                          options={tCNoOptions}
                          component={CustomMultiSelect}
                          isMulti={true}
                          menuPosition="fixed"
                          required
                          onChange={handleChangeTCNos}
                        />
                      </Col>
                    </Row>
                    <hr className="mt-0 mb-1"></hr>
                    <Row>
                      <label className="text-primary">
                        Billing Information
                      </label>
                      <Col lg={3}>
                        <Field
                          label="Project"
                          name="CustomerProjectIDEncrypted"
                          placeholder={"Select Project"}
                          options={projectOptions}
                          component={CustomSelect}
                          required
                          onChange={handleChangeProject}
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Address"
                          name="CustomerProjectAddressIDEncrypted"
                          placeholder={"Select Address"}
                          options={projectAddressOptions}
                          component={CustomSelect}
                          required
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Contact Person"
                          name="CustomerProjectContactPersonIDEncrypted"
                          placeholder={"Select Contact Person"}
                          options={contactPersonOptions}
                          component={CustomSelect}
                          required
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Mode of Dispatch"
                          name="ModeOfDispatch"
                          placeholder={"Select Mode of Dispatch"}
                          options={modeByOptions}
                          component={CustomSelect}
                          required
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Remarks"
                          name="BillingRemarks"
                          placeholder={"Enter Remarks"}
                          component={CustomInput}
                          maxLength={1000}
                        />
                      </Col>
                      <Col lg={3}>
                        {CustomerInSEZ == true && (
                          <span
                            className="me-2 mt-1 fs-12 text-primary"
                            style={{ float: "right" }}
                          >
                            [Registered in SEZ]
                          </span>
                        )}
                        <Field
                          label="GST Number"
                          name="GSTNumber"
                          component={CustomInput}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <hr className="mt-1 mb-1"></hr>
                    <CommonMaterialInformation />
                    <hr className="mt-1 mb-1"></hr>
                    <Row>
                      <Col lg={12}>
                        <Field
                          label="Narration"
                          name="Narration"
                          placeholder={"Enter Narration"}
                          component={CustomTextArea}
                          maxLength={2000}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="stickyBottomButtons">
                    <hr className="mt-1 mb-2"></hr>
                    {InvoiceStatus == false && (
                      <button
                        type="submit"
                        className="btn btn-primary btn-sm me-2"
                      >
                        <i className="fa-solid fa-floppy-disk"></i> Submit
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={(e) => {
                        navigate(-1);
                      }}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </button>
                  </div>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default AddPerformaInvoice;
